import cs from 'classnames';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import fieldset from './fieldset.module.css';

type P = {
  children: ReactNode;
  legend: {
    title: string;
    visible?: boolean;
  };
};

const Fieldset = ({ children, legend }: P) => {
  const { t } = useTranslation();

  return (
    <fieldset className={fieldset.fieldset}>
      {/* TODO legend visible is not properly styled */}
      <legend className={cs({ 'rc-visually-hidden': !legend.visible })}>{t(legend.title)}</legend>
      {children}
    </fieldset>
  );
};

export default Fieldset;
